// extracted by mini-css-extract-plugin
export default {"wrapper":"MYBuKNcBxG1LyPH1GawR","close__button":"mQ8deW9KQcqVhC0Rw32n"};